/* VOYD V9 — correct front-layer overlap + lightweight reveal motion */
(() => {
  const stage = document.querySelector('[data-footer-reveal-stage]');
  const cards = document.querySelector('[data-footer-reveal-cards]');
  const footer = document.querySelector('.site-footer--premium');

  /* Mark when the footer is actually traveling behind the cards. */
  if (stage && cards && footer) {
    let ticking = false;
    const updateUnderlap = () => {
      ticking = false;
      const footerTop = footer.getBoundingClientRect().top;
      const cardsRect = cards.getBoundingClientRect();
      const underlapping = footerTop < cardsRect.bottom && footerTop > cardsRect.top - window.innerHeight * .6;
      stage.classList.toggle('is-footer-underlap', underlapping);
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateUnderlap);
    };
    window.addEventListener('scroll', requestUpdate, { passive:true });
    window.addEventListener('resize', requestUpdate, { passive:true });
    updateUnderlap();
  }

  /* Scroll-in motion for key homepage and footer elements. */
  const selectors = [
    '.home-editorial-tile',
    '.home-category-mosaic__tile',
    '.home-community__cell',
    '.brand-panel',
    '.site-footer--premium .footer-mission',
    '.site-footer--premium .footer-col',
    '.site-footer--premium .footer-bottom'
  ].join(',');
  const items = Array.from(document.querySelectorAll(selectors));

  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(el => el.classList.add('is-visible'));
    return;
  }

  items.forEach((el, index) => {
    el.classList.add('voyd-reveal');
    el.style.transitionDelay = `${Math.min(index % 4, 3) * 45}ms`;
  });

  if (!('IntersectionObserver' in window)) {
    items.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold:.12, rootMargin:'0px 0px -8% 0px' });

  items.forEach(el => observer.observe(el));
})();
